import { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';
import { ButtonMantine, Group, Stack, Title } from 'ui';

import { useHandleAddCardClick } from '../../../hooks/useHandleAddCardClick';
import { CredentialCardList } from './CredentialCards/CredentialCardList';

const CardsOnFile = () => {
  const { handleAddCardClick } = useHandleAddCardClick();
  const navigate = useNavigate();

  const handleClickAddCard = useCallback(() => {
    handleAddCardClick(() => navigate('card'));
  }, [handleAddCardClick, navigate]);

  return (
    <Stack>
      <Group justify="space-between">
        <Title order={2}>Cards On File</Title>
        <ButtonMantine size="sm" variant="subtle" onClick={handleClickAddCard}>
          Add Card
        </ButtonMantine>
      </Group>
      <CredentialCardList isSingleColumn />
    </Stack>
  );
};

export { CardsOnFile };
